import {
  LOAD_SUCCESS_TAGS,
  LOAD_FAIL_TAGS,
  SAVE_SUCCESS_TAGS,
  SAVE_FAIL_TAGS,
  UPDATE_SUCCESS_TAGS,
  UPDATE_FAIL_TAGS,
  DELETE_SUCCESS_TAGS,
  DELETE_FAIL_TAGS,
} from "../actions/tagAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_TAGS:
      action.payload.forEach((item, i) => (item.key = i));
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_TAGS:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_TAGS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_TAGS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_TAGS:
      const updatedListe = [];

      state.data.forEach((item) => {
        if (item.tag_id === action.payload.tag_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_TAGS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_TAGS:
      const filtered = state.data.filter((item) => {
        return item.tag_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_TAGS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
